import React from 'react';

const Contact = (props) => {
  return <div>Contact Page</div>;
};

export default Contact;
